import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Avatar from './Avatar';

export default class AvatarList extends Component {
  static propTypes = {
    users: PropTypes.array,
    companies: PropTypes.array,
    maximum: PropTypes.number,
    total_count: PropTypes.number,
  };

  static defaultProps = {
    users: null,
    companies: null,
    maximum: 5,
    total_count: null,
  }

  render() {
    const items = (this.props.users || this.props.companies);
    const type = (this.props.users ? 'user' : 'company');
    const avatars = items.slice(
      0,
      items.length > this.props.maximum ? this.props.maximum - 1 : this.props.maximum
    ).map((item) => (
      <Avatar
        src={item.avatar}
        href={item.url}
        name={item.name}
        headline={item.headline}
        type={type}
        hover
        className="Avatar--medium u-mr-1"
        key={item.url}
      />
    ));

    const count = (this.props.total_count || items.length);
    const remainingAvatars = count - this.props.maximum <= 0 ? 0 : count - this.props.maximum + 1;
    const textSize = remainingAvatars > 9 ? (remainingAvatars > 99 ? 'u-text-xxxs' : 'u-text-xxs') : 'u-text-xs';
    const rounded = type === 'user' ? 'u-rounded-full' : 'u-rounded-sm';
    return (
      <div className="u-flex">
        {avatars}
        {remainingAvatars > 0 && (
          <div
            style={{ minWidth: '1.5rem', lineHeight: '1.5rem' }}
            className={`${textSize} u-inline-block u-h-6 u-bg-grey-darker ${rounded} u-text-white u-text-center u-align-middle u-font-bold`}
          >
            {`+${remainingAvatars}`}
          </div>
        )}
      </div>
    );
  }
}
